document.addEventListener('DOMContentLoaded', () => {
	var newLocaleCode = document.querySelector('[name="locale_code"]').value;
	var newCountryCode = document.querySelector('[name="country_code"]').value;

	const countryLinks = document.querySelectorAll('.country-items a');
	const languageLinks = document.querySelectorAll('.language-items a');
	const countryInput = document.querySelector('input[name="country_code"]');
	const languageInput = document.querySelector('input[name="locale_code"]');

	const languageList = document.querySelector('.language-items');
	const links = languageList.querySelectorAll('a');

	const html = document.querySelector('html');
	const modal = document.querySelector('.localization-modal');
	const overlay = document.querySelector('.modal-container');
    const closeButton = document.querySelector('.close-localization');
	const applyMarketAndLanguage = document.querySelector('.localization-apply');

	// Country selection
	countryLinks.forEach(link => {
		link.addEventListener('click', function (event) {
			event.preventDefault();

			// Remove .active from all countries
			countryLinks.forEach(item => item.classList.remove('active'));

			// Add .active to the selected country
			this.classList.add('active');

			// Update hidden input with selected country code
			if (countryInput) {
				countryInput.value = this.dataset.value;
				newCountryCode =  this.dataset.value
			}
		});
	});

	// Language selection
	languageLinks.forEach(link => {
		link.addEventListener('click', function (event) {
			event.preventDefault();

			// Remove .active from all languages
			languageLinks.forEach(item => item.classList.remove('active'));

			// Add .active to the selected language
			this.classList.add('active');

			// Update hidden input with selected language code
			if (languageInput) {
				languageInput.value = this.dataset.value;
				newLocaleCode = this.dataset.value;
			}
		});
	});

	// triger to close localization modal
	closeButton.addEventListener('click', () => { closeModal() });

	// triger to close localization modal on click outside modal content
	overlay.addEventListener('click', (event) => {
		if (event.target === overlay || modal.target === overlay) { closeModal() }
	});

	// triger to apply changes
    applyMarketAndLanguage.addEventListener('click', () => {
		closeModal()
		switchMarket(newLocaleCode, newCountryCode)
	});
	


	// Function close Localization Modal
	function closeModal() {
		modal.classList.remove('active');
		html.style.removeProperty('overflow')
		html.style.paddingInlineEnd = '0';
	}
	
	// Function for switch market
	function switchMarket(localeCode, countryCode) {
		const gccCountries = ['om', 'qa', 'bh', 'ae'];
		if (gccCountries.includes(countryCode.toLowerCase())) {
			countryCode = 'gc';
		}
		document.cookie = `localization=AE; path=/; expires=Fri, 09 Feb 2026 17:54:28 GMT; SameSite=Lax`;

		const baseUrl = window.location.origin;
		const path = window.location.pathname;
		const cleanedPath = path.replace(/^\/?(ar|en)(-[a-z]{2})?/, '');
		const newUrl = `${baseUrl}/${localeCode.toLowerCase()}-${countryCode.toLowerCase()}${cleanedPath}`;

		// Redirect to the new market URL
		if (countryCode.toLowerCase() === 'kw' && localeCode.toLowerCase() === 'ar') {
			window.location.href = `${baseUrl}/${cleanedPath}`;
		}
		else if (countryCode.toLowerCase() === 'kw' && localeCode.toLowerCase() === 'en') {
			window.location.href = `${baseUrl}/${localeCode.toLowerCase()}/${cleanedPath}`;
		} else {
			window.location.href = newUrl;
		}
	}

	// CSS switch language behavior (slide rectangle language)
	
	// Initialize the highlight position
	function initializeHighlight() {
		const activeLink = languageList.querySelector('a.active');
		if (activeLink) {
			const rect = activeLink.getBoundingClientRect();
			const listRect = languageList.getBoundingClientRect();
			
			languageList.classList.add('has-highlight');
			
			// Set the initial position and size of the highlight
			languageList.style.setProperty('--highlight-left', `${rect.left - listRect.left}px`);
			
			// Add the CSS custom properties
			const style = document.createElement('style');
			style.textContent = `
				.language-items.has-highlight::before {
					transform: translateX(var(--highlight-left));
				}
			`;
			document.head.appendChild(style);
		}
	}

	// Update highlight position
	function updateHighlight(element) {
		const rect = element.getBoundingClientRect();
		const listRect = languageList.getBoundingClientRect();
		languageList.style.setProperty('--highlight-left', `${rect.left - listRect.left}px`);
	}

	// Return highlight to active element
	function returnToActive() {
		const activeLink = languageList.querySelector('a.active');
		if (activeLink) {
			updateHighlight(activeLink);
		}
	}

	// Event listeners for hover
	links.forEach(link => {
		link.addEventListener('mouseenter', () => {
			updateHighlight(link);
		});
		
		link.addEventListener('click', (e) => {
			e.preventDefault();
			links.forEach(l => l.classList.remove('active'));
			link.classList.add('active');
			updateHighlight(link);
		});
	});

	// Add mouseleave event to the language list
	languageList.addEventListener('mouseleave', returnToActive);

	// Initialize on load
	initializeHighlight();

	// Update highlight position on window resize
	window.addEventListener('resize', () => {
		const activeLink = languageList.querySelector('a.active');
		if (activeLink) {
			updateHighlight(activeLink);
		}
	});

});